<template>
  <div>

    <Head title="Dashboard" />
    <h1 class="mb-8 text-3xl font-bold">Dashboard</h1>

    <section>
      <h2 class="mb-8 text-xl font-medium">
        Statistik
      </h2>
      <div class="grid grid-cols-1 gap-4 mt-8 sm:grid-cols-3">
        <a href="/servers" title="Server anzeigen">
          <div class="flex items-center bg-white border rounded-sm overflow-hidden shadow">
            <div class="p-4 bg-green-400">
              <icon name="server" class="w-10 h-10" />
            </div>
            <div class="px-4 text-gray-700">
              <h3 class="text-sm tracking-wider">Anzahl der Server</h3>
              <p class="text-3xl"> {{ statistics.servers }} </p>
            </div>
          </div>
        </a>
        <a href="/customers" title="Kunden anzeigen">
          <div class="flex items-center bg-white border rounded-sm overflow-hidden shadow">
            <div class="p-4 bg-blue-400">
              <icon name="users" class="fill-white w-10 h-10" />
            </div>
            <div class="px-4 text-gray-700">
              <h3 class="text-sm tracking-wider">Anzahl der Kunden</h3>
              <p class="text-3xl">{{ statistics.customers }}</p>
            </div>
          </div>
        </a>
        <a href="/domains" title="Domains anzeigen">
          <div class="flex items-center bg-white border rounded-sm overflow-hidden shadow">
            <div class="p-4 bg-indigo-400">
              <icon name="domains" class="fill-white w-10 h-10" />
            </div>
            <div class="px-4 text-gray-700">
              <h3 class="text-sm tracking-wider">Anzahl der Domains</h3>
              <p class="text-3xl">{{ statistics.domains }}</p>
            </div>
          </div>

        </a>
      </div>
    </section>
<!--     <div>
      <h2 class="mt-28 mb-8 text-xl text-gray-400 border-b border-b-gray-200">
        Changelogs
      </h2>

      <div class="max-w-3xl">
        <details class="group">
          <summary
            class="bg-primary-200 flex cursor-pointer list-none items-center justify-between py-4 px-8 text-lg text-white text-secondary-900 group-open:text-primary-500">
            20.11.24
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="block h-5 w-5 group-open:hidden">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="hidden h-5 w-5 group-open:block">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
              </svg>
            </div>
          </summary>
          <div class="pb-4 text-secondary-500">
            <ul class="bg-white py-8 px-16 list-disc">
              <li class="mb-4">Bugfix: Sortierung von Feldern mit Datum</li>
              <li class="mb-4">Feature: Filter zum anzeigen von vorgemerkten Kündigungen</li>
              <li class="mb-4">Feature: Neue Funktion unter "Tools" zum automatischen deaktivieren gekündigter Domains
              </li>
              <li class="mb-4">Feature: Neue Tool Funktion zum automatischen deaktivieren gekündigter Domains</li>
            </ul>
          </div>
        </details>
      </div>

    </div> -->
    <h2 class="mt-28 mb-8 text-xl text-gray-400 border-b border-b-gray-400">
      Weitere Informationen
    </h2>
    <div class="grid grid-cols-1 gap-4 mt-8 sm:grid-cols-5">
      <Card-Link target="_blank" iconName="kuma" title="Uptime Kuma" text="Uptime Monitor für Servicekunden. Momentan nur verlinkt, evtl. per Ifram oder API hier die letzten
              Notifications anzeigen?" link="http://web83.r-z-m.org:3001/" />
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import CardLink from '@/Shared/CardLink'
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Head,
    Icon,
    Link,
    CardLink
  },
  layout: Layout,
  props: {
    statistics: Object,
  },
  setup(props) {
    const statistics = props.statistics;
    return {
      statistics
    }
  },
}
</script>
